"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemIcon.default;
  }
});

var _ListItemIcon = _interopRequireDefault(require("./ListItemIcon"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/ListItemIcon/index.js
// module id = 147
// module chunks = 36573943044255 67936617089079